import { createContext } from "react";

export const InputContext = createContext<
  Partial<{
    inputId: string;
    icon: string;
    setIcon: (icon: string | undefined) => void;
  }>
>({});
